/* unplugin-vue-components disabled */import { render } from "./exhibitions.vue?vue&type=template&id=dbadaa0c&scoped=true"
import script from "./exhibitions.vue?vue&type=script&lang=js"
export * from "./exhibitions.vue?vue&type=script&lang=js"

import "./exhibitions.vue?vue&type=style&index=0&id=dbadaa0c&scoped=true&lang=scss"
import "./exhibitions.vue?vue&type=style&index=1&id=dbadaa0c&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbadaa0c"]])

export default __exports__